import _ from 'lodash';
import styled from 'styled-components';

export const Container = styled.div`
  color: ${(props) => _.get(props.colors, [props.value], null)};
`;
